/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  SelectorItemObject,
  SelectorItemObjectFromJSON,
  SelectorItemObjectFromJSONTyped,
  SelectorItemObjectToJSON
} from './SelectorItemObject'

/**
 *
 * @export
 * @interface ResponseDataSelectorCommon
 */
export interface ResponseDataSelectorCommon {
  /**
   *
   * @type {number}
   * @memberof ResponseDataSelectorCommon
   */
  status?: number
  /**
   *
   * @type {SelectorItemObject}
   * @memberof ResponseDataSelectorCommon
   */
  data?: SelectorItemObject
}

export function ResponseDataSelectorCommonFromJSON(json: any): ResponseDataSelectorCommon {
  return ResponseDataSelectorCommonFromJSONTyped(json, false)
}

export function ResponseDataSelectorCommonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseDataSelectorCommon {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : SelectorItemObjectFromJSON(json['data'])
  }
}

export function ResponseDataSelectorCommonToJSON(value?: ResponseDataSelectorCommon | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: SelectorItemObjectToJSON(value.data)
  }
}
